// 高新技术产品

import {useState} from "react";
import {Form, Input, Descriptions, Button, Radio, Select, Table, Space, Checkbox, Typography} from "antd";
import {gql, useMutation, useSubscription} from "@apollo/client";
import {chatAI} from "./chatAI";
import {上年度销售收入字段} from "./config"
import {bigIntMoney10000ToString, money10000ToString, string10000ToMoney} from "./Utils";
import {UploadOutlined} from '@ant-design/icons';
import {SelectUpload} from "./component/SelectUpload";
import {Attachments} from "./component/Attachments";

const {TextArea} = Input;
const {Title, Paragraph, Text, Link} = Typography;
export default function Gxcp() {
    const [value, setValue] = useState(window.location.hash.split("?")[1] || '');

    const handleChange = (newValue) => {
        setValue(newValue);
        window.location.hash = (window.location.hash.split("?")[0] || window.location.hash) + '?' + newValue
    };

    const [form] = Form.useForm();
    const {data: theRDData, loading: theMndsbDataLoading} = useSubscription(
        gql`subscription MySubscription($id: uuid = "") {
            gxjscp_by_pk(id: $id) {
                PGjjszb
                PJzys
                PZscqqk
                Psfzycpstatus
                cod
                created_at
                id
                mndsb
                updated_at
                technologyS
                shr
                productName
                mndsbObj {
                    _glykj
                    _jscxgl
                    _kjcgzh
                    _zscqjz
                    basics_cost
                    china_cost
                    company
                    companyObj {
                        clsj
                        created_at
                        id
                        qymc
                        tyshxydm
                        updated_at
                    }
                    created_at
                    ent_hr_abroed
                    ent_hr_age1
                    ent_hr_age2
                    ent_hr_age3
                    ent_hr_age4
                    ent_hr_bachelor
                    ent_hr_doctor
                    ent_hr_ext
                    ent_hr_forg
                    ent_hr_junior
                    ent_hr_master
                    ent_hr_mechanic
                    ent_hr_middle
                    ent_hr_on_job
                    ent_hr_part
                    ent_hr_primary
                    ent_hr_senior
                    ent_hr_total
                    ent_hr_tsdplan
                    enterprise_income
                    year
                }
                attachments {
                    updated_at
                    text
                    path
                    name
                    item
                    id
                    description
                    created_at
                }
            }
        }
        `, {
            variables: {id: value},
            shouldResubscribe: true
        },
    )
    const [update_gxjscp_by_pk, {error}] = useMutation(gql`mutation MyMutation($id: uuid = "", $gxjscp: gxjscp_set_input = {}) {
        update_gxjscp_by_pk(pk_columns: {id: $id}, _set: $gxjscp) {
            id
        }
    }
    `);
    const gxcpInitialValues = {...(theRDData || {}).gxjscp_by_pk};
    if ((theRDData || {}).gxjscp_by_pk) {
        for (let k of 上年度销售收入字段) {
            if ((theRDData || {}).gxjscp_by_pk[k]) {
                gxcpInitialValues[k] = money10000ToString((theRDData || {}).gxjscp_by_pk[k])
            }
        }
    }
    const inputs = (form) => [
        ['关键技术及主要技术指标 (限400字) ', 'PGjjszb', `请编写${form.getFieldValue('productName')}产品（含具体参数）关键技术和对${form.getFieldValue('productName')}产品的主要技术指标，需要逐项说明，例如：1、采用什么技术，实现什么； 2、什么设计，提高什么性能。 3、什么设计，实现什么，提高了什么`],
        ['与同类产品（服务）的竞争优势 (限400字) ', 'PJzys', `请写出，本产品${form.getFieldValue('productName')}与同类产品的主要竞争优势体现为：通过对公司自主专利技术的实施，实现什么，并结合公司独创的什么及什么技术，实现什么与什么于一体；开发什么产品，提高其强度和整体什么性能，可以解决什么问题。`],
        ['知识产权获得情况及其对产品（服务）在技术上发挥的支持作用 (限400字) ', 'PZscqqk', `请编写出本项目${form.getFieldValue('productName')}产品有效实施专利（)等专利技术，研制的${form.getFieldValue('productName')}产品有效解决了什么技术难题，产品经什么评估，产品整体技术水平达到国际先进水平。`],
    ]
    return (<>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <label title={'RD ID'} style={{width: '70px'}}>ps ID：</label>
            <Input value={value} onChange={(e) => {
                handleChange(e.target.value)
            }}/>
        </div>
        <div style={{padding: '10px'}}></div>
        {(theRDData || {}).gxjscp_by_pk && <>
            <Descriptions title=" " bordered>
                <Descriptions.Item label="企业名称"
                                   span={2}>{theRDData.gxjscp_by_pk.mndsbObj.companyObj.qymc}
                </Descriptions.Item>
                <Descriptions.Item label="申报年度"
                                   span={2}>{theRDData.gxjscp_by_pk.mndsbObj.year}</Descriptions.Item>
                <Descriptions.Item label="统一社会信用代码"
                                   span={2}>{theRDData.gxjscp_by_pk.mndsbObj.companyObj.tyshxydm}</Descriptions.Item>
                <Descriptions.Item
                    label="成立时间"
                    span={2}>{new Date(theRDData.gxjscp_by_pk.mndsbObj.companyObj.clsj).toLocaleDateString()}</Descriptions.Item>
                <Descriptions.Item label="高新技术产品编号 ps"
                                   span={2}>{theRDData.gxjscp_by_pk.cod}</Descriptions.Item>
                <Descriptions.Item label="高新技术产品名称"
                                   span={2}>{theRDData.gxjscp_by_pk.productName}</Descriptions.Item>
            </Descriptions>
            <div style={{padding: '10px'}}></div>
            <Form
                name="basic"
                labelCol={{
                    span: 32,
                }}
                wrapperCol={{
                    span: 32,
                }}
                style={{
                    maxWidth: 800,
                }}
                layout="vertical"
                initialValues={gxcpInitialValues}
                // layout={'inline'}
                onFinish={(values) => {
                    console.log(values)
                    for (let k of 上年度销售收入字段) {
                        if (values[k]) {
                            values[k] = string10000ToMoney(values[k])
                        }
                    }

                    update_gxjscp_by_pk({
                        variables: {
                            id: value,
                            gxjscp: values
                        }
                    }).fankui().then(value1 => window.history.back())
                    // insert_mndsb({variables: {year: e.year.$y, company: theCompanyData.company[0].id}})
                }}
                onFinishFailed={(e) => {
                    console.error(e)
                }}
                autoComplete="off"
                form={form}
            >
                <Form.Item
                    label="编号 ps"
                    name="cod"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="产品（服务）名称"
                    name="productName"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="技术来源"
                    name="technologyS"
                    rules={[{required: true, message: '请选择'}]}
                >
                    <Select>
                        <Select.Option value="0">请选择</Select.Option>
                        <Select.Option value="1">大专院校</Select.Option>
                        <Select.Option value="2">地方属科研院所</Select.Option>
                        <Select.Option value="3">其他企业技术</Select.Option>
                        <Select.Option value="4">引进技术本企业消化创新</Select.Option>
                        <Select.Option value="5">国外技术</Select.Option>
                        <Select.Option value="6">企业自有技术</Select.Option>
                        <Select.Option value="7">中央属科研院所</Select.Option>

                    </Select>
                </Form.Item>
                <Form.Item
                    label="上年度销售收入（万元）"
                    name="shr"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item label="是否主要产品（服务）" name="Psfzycpstatus">
                    <Radio.Group>
                        <Radio value={true}>是</Radio>
                        <Radio value={false}>否</Radio>
                    </Radio.Group>
                </Form.Item>
                {/*<Form.Item label="知识产权编号" name="Zscqbh">*/}
                {/*</Form.Item>*/}
                <Space>
                    <Button onClick={() => {
                        inputs(form).map(i => chatAI(i[2], form.getFieldValue(i[1]), (answer) => form.setFieldValue(i[1], answer)))
                    }}>一键 ChatGPT</Button>
                    <Button onClick={() => {
                        inputs(form).map(i => chatAI(i[2], form.getFieldValue(i[1]), (answer) => form.setFieldValue(i[1], answer)), 'bing')
                    }}>一键 Bing</Button>
                </Space>
                {inputs(form).map((i, index) => <>
                    <Form.Item
                        label={i[0]}
                        name={i[1]}
                        rules={[{required: true, message: i[0]}]}
                    >
                        <TextArea showCount autoSize/>
                    </Form.Item>
                    <Space>
                        <Button onClick={() => {
                            const i = inputs(form)[index]
                            chatAI(i[2], form.getFieldValue(i[1]), (answer) => form.setFieldValue(i[1], answer))
                        }}>ChatGPT</Button>
                        <Button onClick={() => {
                            const i = inputs(form)[index]
                            chatAI(i[2], form.getFieldValue(i[1]), (answer) => form.setFieldValue(i[1], answer), 'bing')
                        }}>Bing</Button>
                    </Space>
                </>)}
                <div style={{padding: '10px'}}></div>
                <h3>附件 <UploadOutlined/></h3>
                <SelectUpload
                    item={value}
                    nameList={["关键技术的具体说明", "技术指标的具体说明", "相关的生产批文", "认证认可和资质证书", "产品质量检验报告", "用户使用报告", "销售合同", "销售发票", "其他企业高新技术产品附件"]}/>
                <Attachments attachments={theRDData.gxjscp_by_pk.attachments}/>
                <Paragraph>
                    请上传企业高新技术产品（服务）的关键技术和技术指标的具体说明，相关的生产批文、认证认可和资质证书、产品质量检验报告等材料。
                    <br/>
                    <h5>认定机构具体要求如下：</h5>
                    1. 企业高新技术产品（服务）的关键技术和技术指标的具体说明；<br/>
                    2. 相关的生产批文、认证认可和资质证书、产品质量检验报告、用户使用报告、销售合同、销售发票等。<br/>
                    <h5>附件格式要求：</h5>

                    1、证明材料扫描上传。<br/>

                    2、只支持非加密PDF格式的文件上传。<br/>

                    3、单个文件大小不要超过4M。
                </Paragraph>
                <Form.Item wrapperCol={{offset: 8, span: 8}}>
                    <Button type="primary" htmlType="submit">
                        确定
                    </Button>
                </Form.Item>
            </Form>


        </>}
    </>)
}
